var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10 10"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "label_svg__a",
    d: "M620.54 426.998c.14.002.273.058.372.158a.535.535 0 010 .76.533.533 0 01-.76 0 .535.535 0 010-.76.535.535 0 01.388-.158zm.008-.5a1.038 1.038 0 00-.748 1.771 1.04 1.04 0 001.466 0 1.042 1.042 0 000-1.467c-.19-.19-.448-.3-.718-.304zm-2.045-.994l3.814.274 5.132 5.136a.148.148 0 010 .204l-3.339 3.341a.148.148 0 01-.203 0l-5.13-5.136zm-.07-.504a.25.25 0 00-.179.084c-.15.081-.266.215-.253.395l.278 3.898a.45.45 0 00.13.284l5.146 5.152c.25.25.659.25.909 0l3.338-3.342c.25-.25.25-.66 0-.91l-5.146-5.152a.448.448 0 00-.284-.13h-.001l-3.892-.278.003.002a.519.519 0 00-.045-.002l.001-.001h-.006z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#label_svg__a",
    transform: "translate(-618 -425)"
  })));
}

export default SvgLabel;